import {CustomFieldTO} from 'generated/JavaTO'
import _ from 'lodash'

export function cfAttrValueDstFieldsToCFDefs(cfDefs: CustomFieldTO[], value: string) {
	const dstFields = _.uniq(value?.split(' ').map(x => x.trim()).filter(x => x))
	const retCFDefs = _.uniq(cfDefs.filter(x => dstFields.includes(x.dstField)))
	return retCFDefs
}